<template>
  <!-- begin stream -->
  <fade-translate-transition-group
    :class-name="`streams margin-bottom_base-phone margin_centered-phone parent column  ${className}`"
    tag="div"
  >
    <!-- begin streamChoice -->
    <div
      v-if="isStreamInited"
      :key="0"
      :data-index="0"
      class="streamChoice width_fill relative index_big parent row shadow_spread margin-bottom_small margin-top_small background-color_white">
      <span class="streamChoice__name font-weight_semibold baseChild h-between">
        {{ !selectedStream ? 'Выбрать стрим' : selectedStream }}
      </span>
      <base-button
        :action="switchListChoicesState"
        class-name="baseChild streamChoice__button"
        label="Открыть "
        unstyled
      >
        <chevron-icon
          :position="isStreamChoicesOpened ? 'up' : 'down'"
        />

      </base-button>
      <!-- begin streamList -->
      <transition
        appear
        name="fadeTranslateToBottom">
        <ul
          v-if="isStreamChoicesOpened"
          :aria-expended="isStreamChoicesOpened"
          class="streamsList popupList absolute"
        >
          <!-- begin streamName -->
          <li
            v-for="(channel, index) in channels"
            :key="index"
            class="streamName">
            <base-button
              :action="selectStream(channel)"
              label="Выбрать стрим"
              unstyled
            >
              {{ channel }}
            </base-button>

          </li>
          <!-- end streamName -->
        </ul>

      </transition>
      <!-- end streamList -->
    </div>
    <!-- end streamChoice -->
    <!-- begin streamFrame -->
    <div
      v-if="isStreamInited"
      :key="1"
      :data-index="1"
      class="streamFrame">
      <iframe
        id="matchStreamFrame"
        :src="selectedStreamUrl"
        height="168"
        class="width_fill-phone"
        width="229"
        frameborder="0"
        scrolling="no"
        allowfullscreen="true"/>
    </div>
    <!-- end streamFrame -->
  </fade-translate-transition-group>
  <!-- end stream -->
</template>

<script>
import { timeout } from "@/constants/pureFunctions";

export default {
  name: "MatchStreams",
  props: {
    className: {
      type: String,
      required: false,
      default: ""
    },
    channels: {
      type: Array,
      required: true,
      validator: function(value) {
        // Валидация каналов передаваемых для отображения.
        return value.every(channelName => typeof channelName === "string");
      }
    }
  },
  data: () => ({
    isStreamChoicesOpened: false,
    selectedStreamUrl: "",
    twitchUrl: "https://player.twitch.tv/?autoplay=false&channel=",
    selectedStream: "",
    isStreamInited: false
  }),
  mounted() {
    this.$nextTick(() => {
      timeout(() => {
        this.$set(this, "isStreamInited", true);

        this.setStreamUrl(this.channels[0]);
      }, 600);
    });
  },
  methods: {
    switchListChoicesState() {
      this.$set(this, "isStreamChoicesOpened", !this.isStreamChoicesOpened);
    },
    setStreamUrl(streamName) {
      this.$set(this, "selectedStreamUrl", this.twitchUrl + streamName);
    },
    // Каррированная функция для смены имени стрима.
    selectStream(streamName) {
      return () => {
        this.setStreamUrl(streamName);

        this.$set(this, "selectedStream", streamName);

        this.switchListChoicesState();
      };
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../assets/sass/conf/_colors.sass'
@import '../assets/sass/conf/_sizes.sass'
@import '../assets/sass/conf/_breakpoints.sass'
.streams
  min-width: em(230, 12)

  @include breakpoint($phone-less)
      margin-top: 1.5em

.popupMatchStreams
  @include breakpoint($tablet-less)
      justify-content: center
.streamsList
  transform: translateY(-2px)
  border-top-right-radius: 0
  border-top-left-radius: 0

.streamChoice
	&__name
		padding: em(5) 0 em(5) em(11)
	&__button
		max-width: em(34, 12)
.streamFrame > iframe
    max-width: em(230, 12)
    max-height: em(126, 12)

</style>



// WEBPACK FOOTER //
// src/components/MatchStreams.vue